// Use exisiting loader util from google-map-react so we avoid conflicts in maps api load
import googleMapLoader from "google-map-react/lib/loaders/google_map_loader"
import { GOOGLE_MAPS_API_KEY } from "../constants/config"
import { pick } from "../utils"

const defaultMapsConfig = { key: GOOGLE_MAPS_API_KEY, libraries: ["places"] }
const defaultKeys = pick(Object.keys(defaultMapsConfig))

let cachedGeocoder = null
let cachedAutocompleteService = null

export const getGoogleMapsApi = (config = {}) => {
  const { key, libraries } = { ...defaultMapsConfig, ...config }
  return googleMapLoader({ key, libraries: libraries.join(",") })
}

export const getGeocoder = (config = {}) => {
  if (cachedGeocoder) return Promise.resolve({ ...cachedGeocoder })
  return getGoogleMapsApi(defaultKeys(config)).then(({ Geocoder, GeocoderLocationTypes, GeocoderStatus }) => {
    cachedGeocoder = {
      geocoder: new Geocoder(),
      locationTypes: GeocoderLocationTypes,
      statusCodes: GeocoderStatus
    }
    return { ...cachedGeocoder }
  })
}

export const getAutocompleteService = (config = {}) => {
  if (cachedAutocompleteService) return Promise.resolve({ ...cachedAutocompleteService })
  return getGoogleMapsApi(defaultKeys(config)).then(({ places }) => {
    cachedAutocompleteService = {
      autocompleteService: new places.AutocompleteService(),
      statusCodes: places.PlacesServiceStatus
    }

    return { ...cachedAutocompleteService }
  })
}



// WEBPACK FOOTER //
// ./src/apis/google-maps.js